module.exports = __webpack_public_path__ + "img/ep-sorciere.3a2d2a12.jpg";